import React from 'react'

import type { VideoPlayerProps } from './VideoPlayer.types'
import { VideoPlayerDefault } from '../VideoPlayerDefault/VideoPlayerDefault'
import { VideoPlayerInline } from '../VideoPlayerInline/VideoPlayerInline'
import { VideoThumbnail } from '../VideoThumbnail/VideoThumbnail'

export const VideoPlayer: React.FC<VideoPlayerProps> = props => {
  // The inline flow renders its own preview variant (playlist list with
  // non-interactive thumbnails), so previewOnly is passed through to it to
  // keep the layout identical to the interactive version.
  if (props.inline && props.playlistId) {
    return (
      <VideoPlayerInline
        accountId={props.accountId}
        policyKey={props.policyKey}
        playlistId={props.playlistId}
        testId={props.testId}
        previewOnly={props.previewOnly}
      />
    )
  }

  // Default flow preview: render just the poster thumbnail without loading the
  // Brightcove player or its scripts.
  if (props.previewOnly) {
    return (
      <VideoThumbnail
        accountId={props.accountId}
        policyKey={props.policyKey}
        playlistId={props.playlistId}
        videoId={props.videoId}
        testId={props.testId}
        previewOnly
      />
    )
  }

  return <VideoPlayerDefault {...props} />
}
